interface CognitoParams{
  clientId: string;
  url: string;
  redirectUri: string;
}

interface RedirectParams {
  login: string;
  newUser: string;
}

const hostname = window.location.hostname;

const API_MAP: { [key: string]: string } = {
  "alumni.thenowportal.com": "https://api.thenowportal.com",
  "alumni.dev.aws.thenowportal.com": "https://api.dev.aws.thenowportal.com",
  "alumni.stg.thenowportal.aws-preprod.nbcuni.com": "https://stg.api.aws-preprod.nbcuni.com",
  "alumni.qa.aws.thenowportal.com": "https://api.qa.aws.thenowportal.com",
  "alumni.qa2.aws.thenowportal.com": "https://api.qa2.aws.thenowportal.com",
  localhost: "https://api.dev.aws.thenowportal.com",
};

const COGNITO_MAP: {[key:string]: CognitoParams} = {
  "alumni.thenowportal.com": {
    clientId: "6teetv8a6e39e0mrd9mcfj2fpn",
    url: "https://auth.thenowportal.com",
    redirectUri: "https://thenowportal.com",
  },
  "alumni.dev.aws.thenowportal.com": {
    clientId: "7ee5kgr14kedd9eddjr6j6kf7n",
    url: "https://us-east-1.auth.dev.aws.thenowportal.com",
    redirectUri: "https://cdn.dev.aws.thenowportal.com",
  },
  "alumni.stg.thenowportal.aws-preprod.nbcuni.com": {
    clientId: "1ua7tn199ida6v5928hodapjni",
    url: "https://auth.stg.thenowportal.aws-preprod.nbcuni.com",
    redirectUri: "https://stg.thenowportal.aws-preprod.nbcuni.com",
  },
  "alumni.qa.aws.thenowportal.com": {
    clientId: "1mngem2kn1606b7vgv36udj8h4",
    url: "https://us-east-1.auth.qa.aws.thenowportal.com",
    redirectUri: "https://cdn.qa.aws.thenowportal.com",
  },
  "alumni.qa2.aws.thenowportal.com": {
    clientId: "1i3cujp7bp8iad5tprvuuql0j6",
    url: "https://us-east-1.auth.qa2.aws.thenowportal.com",
    redirectUri: "https://cdn.qa2.aws.thenowportal.com",
  },
  localhost: {
    clientId: "7ee5kgr14kedd9eddjr6j6kf7n",
    url: "https://us-east-1.auth.dev.aws.thenowportal.com",
    redirectUri: "https://cdn.dev.aws.thenowportal.com",
  },
};

/* eslint-disable max-len */
const REDIRECT_MAP: {[key:string]: RedirectParams} = {
  "alumni.thenowportal.com": {
    login: "https://alumni.thenowportal.com",
    newUser: "https://nbcuextcb2c.b2clogin.com/nbcuextcb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_NBCUEXTC_PR_NOWPORTAL_TOTP&client_id=a79e3ddd-54be-498d-9ff1-568afd78d764&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fiefcustpolicystorageprd.blob.core.windows.net%2Fnowportal%2Flogoutafteraccountupdate.html&scope=openid&response_type=code&prompt=login",
  },
  "alumni.dev.aws.thenowportal.com": {
    login: "https://alumni.dev.aws.thenowportal.com",
    newUser: "https://nbcuextcstgb2c.b2clogin.com/nbcuextcstgb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_NBCUEXTC_PR_NOWPORTAL_TOTP&client_id=17005468-cab4-411f-a97c-5639183f6ee1&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fiefcustompolicystorage.blob.core.windows.net%2Fnowportal%2Flogoutafteraccountupdate.html&scope=openid&response_type=code&prompt=login",
  },
  "alumni.stg.thenowportal.aws-preprod.nbcuni.com": {
    login: "https://alumni.stg.thenowportal.aws-preprod.nbcuni.com",
    newUser: "https://nbcuextcstgb2c.b2clogin.com/nbcuextcstgb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_NBCUEXTC_PR_NOWPORTAL_TOTP&client_id=17005468-cab4-411f-a97c-5639183f6ee1&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fiefcustompolicystorage.blob.core.windows.net%2Fnowportal%2Flogoutafteraccountupdate.html&scope=openid&response_type=code&prompt=login",
  },
  "alumni.qa.aws.thenowportal.com": {
    login: "https://alumni.qa.aws.thenowportal.com",
    newUser: "https://nbcuextcstgb2c.b2clogin.com/nbcuextcstgb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_NBCUEXTC_PR_NOWPORTAL_TOTP&client_id=17005468-cab4-411f-a97c-5639183f6ee1&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fiefcustompolicystorage.blob.core.windows.net%2Fnowportal%2Flogoutafteraccountupdate.html&scope=openid&response_type=code&prompt=login",
  },
  "alumni.qa2.aws.thenowportal.com": {
    login: "https://alumni.qa2.aws.thenowportal.com",
    newUser: "https://nbcuextcstgb2c.b2clogin.com/nbcuextcstgb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_NBCUEXTC_PR_NOWPORTAL_TOTP&client_id=17005468-cab4-411f-a97c-5639183f6ee1&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fiefcustompolicystorage.blob.core.windows.net%2Fnowportal%2Flogoutafteraccountupdate.html&scope=openid&response_type=code&prompt=login",
  },
  localhost: {
    login: "https://alumni.dev.aws.thenowportal.com",
    newUser: "https://nbcuextcstgb2c.b2clogin.com/nbcuextcstgb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_NBCUEXTC_PR_NOWPORTAL_TOTP&client_id=17005468-cab4-411f-a97c-5639183f6ee1&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fiefcustompolicystorage.blob.core.windows.net%2Fnowportal%2Flogoutafteraccountupdate.html&scope=openid&response_type=code&prompt=login",
  },
};
/* eslint-enable max-len */

// Use the mapping or default to the fallback
const API_PATH = API_MAP[hostname] || "https://default-api.thenowportal.com/api";
const COGNITO_PATH = COGNITO_MAP[hostname] || "alumni.dev.aws.thenowportal.com";
const REDIRECTS = REDIRECT_MAP[hostname] || "alumni.dev.aws.thenowportal.com";
const MAINTENANCE_PAGE = "http://maintenance.nbcuni.com/";

const RECAPTCHA_KEY = "6LefnqEsAAAAAM4qsv80Pc1b-knByLzrZBkP2fZs";

export { API_PATH, COGNITO_PATH, MAINTENANCE_PAGE, RECAPTCHA_KEY, REDIRECTS };
